import { MijnRoute } from '../../mijn-navigatie.model';

export const SELF_SERVICE: MijnRoute = {
    path: 'zelf-regelen',
    navigationEvent: 'toZelfRegelen',
    regex: /^\/zelf-regelen$/,
    webcomponent: 'mijn-klant-zelfservice-webcomponent'
};
